import React from "react";
import PropTypes from "prop-types";
import { Image } from "@learningblocks/shared-components";
import HintModalIcon from "@common/images/hint-modal-icon.svg";

import style from "./style.module.scss";

export function TitleIcon(props) {
  const className = `${style.titleIcon} ${props.className}`;
  return (
    <div className={className}>
      <Image src={HintModalIcon} alt="hint_icon" />
    </div>
  );
}

TitleIcon.propTypes = {
  /**
   * classname for custom style of component
   */
  className: PropTypes.string,
};

TitleIcon.defaultProps = {
  className: "",
};
